import { getFormValues, destroy, getFormInitialValues } from 'redux-form';
import http from '../../../shared/http';
import _get from 'lodash/get';
import _find from 'lodash/find';
import qs from 'qs';

import endpoints from '../../../../config/endpoints';
import {selectors as parentSelectors} from '../../profile';
import { getDateRangeFromCalendar } from '../../../shared/calendar';

const defaultInitialState = {
	fields: {
		offers: null,
		target_approve: null
	},
	dailyApprovesList: [],
	initialFormData: {
		trash_percent: 20
	},
	isShow: false,
	isBlockedSubmitButton: false
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-approve-daily-form`;
	const SUBMIT_FORM_OK = `${namespace}/${stateNodeName}-submit-approve-daily-form-ok`;
	const SUBMIT_FORM_FAIL = `${namespace}/${stateNodeName}-submit-approve-daily-form-fail`;

	const SET_INITIAL_FORM_DATA = `${namespace}/${stateNodeName}-SET_INITIAL_FORM_DATA`;

	const OFFERS_LOOKUP_SUCCESS = `${namespace}/${stateNodeName}-OFFERS_LOOKUP_SUCCESS`;

	const FETCH_APPROVE_DAILY_LIST_OK = `${namespace}/${stateNodeName}-FETCH_APPROVE_DAILY_LIST_OK`;
	const FETCH_APPROVE_DAILY_LIST_NOT_OK = `${namespace}/${stateNodeName}-FETCH_APPROVE_DAILY_LIST_NOT_OK`;

	const DELETE_OK = `${namespace}/${stateNodeName}-DELETE_OK`;

	const initialState = { ...defaultInitialState };

	const actions = {
		toggleApproveDailyForm: () => dispatch => {
			dispatch({ type: TOGGLE_FORM  });
		},
		submitApproveDaily: (formData) => (dispatch, getState) => {
			const formValues = getFormValues('approveDailyForm')(getState());
			const formInitialValues = getFormInitialValues('approveDailyForm')(getState());
			const is_manually_changed_trash_percent = formValues.trash_percent !== formInitialValues.trash_percent;

			const data = {
				...formData,
				country_code: _get(formData, 'country_code.0.value'),
				offer_id: _get(formData, 'offer_id.0.value'),
				affiliate_id: getState().affiliateProfile.affiliateId,
				trash_percent: formData.trash_percent,
				is_manually_changed_trash_percent,
				random_approve_percent_part: formInitialValues.random_approve_percent_part || 1 + Math.random()
			};
			const isUpdateMode = !!formData.id;
			return http({
				url: isUpdateMode
					? `${endpoints.CONVERSIONS.DAILY_APPROVE}/${formData.id}`
					: endpoints.CONVERSIONS.DAILY_APPROVE,
				method: isUpdateMode ? 'put' : 'post',
				data: data,
				actions: [ SUBMIT_FORM_OK, SUBMIT_FORM_FAIL ]
			})(dispatch).then(action => {
				if (action.type === SUBMIT_FORM_OK) {
					dispatch(destroy('approveDailyForm'));
					dispatch(actions.toggleApproveDailyForm());
					dispatch(actions.fetchApproveDailyList());
				}
			});
		},
		fetchApproveDailyList: () => (dispatch, getState) => {
			return http({
				url: `${endpoints.CONVERSIONS.DAILY_APPROVE}/${getState().affiliateProfile.affiliateId}`,
				method: 'get',
				actions: [ FETCH_APPROVE_DAILY_LIST_OK, FETCH_APPROVE_DAILY_LIST_NOT_OK ]
			})(dispatch);
		},
		dailyOffersLookup: text => (dispatch, getState) => {
			const { affiliate_id } = selectors.getFormData(getState());
			const query = qs.stringify({ query: text, affiliate_id, onlyAvailable: true, isShowedRemoved: true });

			const request = http({
				url: `${endpoints.LOOKUPS.OFFERS}?${query}`,
				method: 'get',
				actions: [OFFERS_LOOKUP_SUCCESS]
			});

			return request(dispatch).then(action => {
				if (action.type === OFFERS_LOOKUP_SUCCESS) {
					return { options: action.payload.data.map(item => ({ value: item.id, label: item.text })) };
				}
			});
		},
		setInitialFormData: id => (dispatch, getState) => {
			const data = _find(selectors.getDailyApprovesList(getState()), { id });
			data.offer_id = [{ value: data.offer_id, label: data.offer}];
			data.country_code = [{ value: data.country_code, label: data.country}];
			dispatch({ type: SET_INITIAL_FORM_DATA, payload: data });
		},
		deleteApproveDaily: (id) => (dispatch, getState) => {
			return http({
				url: `${endpoints.CONVERSIONS.DAILY_APPROVE}/${id}`,
				method: 'delete',
				actions: [ DELETE_OK ]
			})(dispatch)
				.then(action => {
					if (action.type === DELETE_OK) {
						dispatch(actions.fetchApproveDailyList());
					}
				});
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state, approveDailyForm: {
				...state.approveDailyForm, isShow: !state.approveDailyForm.isShow
			}
		}),
		[SET_INITIAL_FORM_DATA]: (state, action) => ({
			...state, approveDailyForm: {
				...state.approveDailyForm,
				initialFormData: action.payload
			}
		}),
		[FETCH_APPROVE_DAILY_LIST_OK]: (state, action) => ({
			...state, approveDailyForm: {
				...state.approveDailyForm, dailyApprovesList: action.payload.data
			}
		})
	};

	const selectors = {
		getFormData: state => {
			const formValues = getFormValues('approveDailyForm')(state);
			if (!formValues) return {};

			return {
				...formValues,
				offers: formValues.offers && formValues.offers.map(i => i.value),
				countries: formValues.countries && formValues.countries.map(i => i.value),
				date_range: getDateRangeFromCalendar(parentSelectors.affiliateApproveIncreaseCalendar(state)),
				affiliate_id: state.affiliateProfile.affiliateId
			};
		},
		getIsApproveDailyFormVisible: state => state[namespace][stateNodeName].isShow,
		getFormInitialData: state => state[namespace][stateNodeName].initialFormData,
		getDailyApprovesList: state => state[namespace][stateNodeName].dailyApprovesList
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/approve-daily-form/index.js